const plausibleScript = document.getElementById("plausible")

function updateCustomProperty(name, value) {
  plausibleScript.setAttribute("event-" + name, value)
}

export function setPlausibleUserSegment(userSegment) {
  updateCustomProperty("user-segment", userSegment)
}

export function triggerPageview() {
  window.plausible("pageview")
}

export function triggerEvent(eventName) {
  window.plausible(eventName)
}
